export enum UserRoles {
    admin = 'Admin',
    editor = 'Editor',
    reader = 'Viewer'
}
